import { container } from "tsyringe";
import { SocketWrapperMessage } from "../../domain/model/webSocket";
import { RentalServiceEvent } from "../../domain/events/rentalServicesEvent";
import { getCookieShopify } from "../../application/services/cookieService";
const ESIM_TIMEOUT_MS = 10000;
export class EsimProvider {
    constructor() {
        this.validateEsim = (request) => {
            return new Promise((resolve) => {
                let timeoutId;
                let resolved = false;
                const cleanup = () => {
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }
                };
                // Subscribe to the result event
                const registry = this.application.handle(RentalServiceEvent.ESIM_VALIDATE_RESULT, (payload) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    if (resolved)
                        return;
                    resolved = true;
                    cleanup();
                    registry
                        .then((reg) => {
                        if (reg && reg.unregister) {
                            reg.unregister();
                        }
                    })
                        .catch(() => { });
                    resolve({
                        available: (_a = payload === null || payload === void 0 ? void 0 : payload.available) !== null && _a !== void 0 ? _a : false,
                        productId: payload === null || payload === void 0 ? void 0 : payload.productId,
                        priceUsd: (_b = payload === null || payload === void 0 ? void 0 : payload.priceUsd) !== null && _b !== void 0 ? _b : 0,
                        priceLocal: (_c = payload === null || payload === void 0 ? void 0 : payload.priceLocal) !== null && _c !== void 0 ? _c : 0,
                        esimTotalUsd: (_d = payload === null || payload === void 0 ? void 0 : payload.esimTotalUsd) !== null && _d !== void 0 ? _d : 0,
                        esimTotalLocal: (_e = payload === null || payload === void 0 ? void 0 : payload.esimTotalLocal) !== null && _e !== void 0 ? _e : 0,
                        conversionRate: (_f = payload === null || payload === void 0 ? void 0 : payload.conversionRate) !== null && _f !== void 0 ? _f : 0,
                        coverageDays: (_g = payload === null || payload === void 0 ? void 0 : payload.coverageDays) !== null && _g !== void 0 ? _g : 0,
                        destination: (_h = payload === null || payload === void 0 ? void 0 : payload.destination) !== null && _h !== void 0 ? _h : request.destinationCountry,
                        termsAndConditionsUrl: payload === null || payload === void 0 ? void 0 : payload.termsAndConditionsUrl,
                        maxQuantity: payload === null || payload === void 0 ? void 0 : payload.maxQuantity,
                    });
                });
                // Set timeout for fail-closed response
                timeoutId = setTimeout(() => {
                    if (resolved)
                        return;
                    resolved = true;
                    registry
                        .then((reg) => {
                        if (reg && reg.unregister) {
                            reg.unregister();
                        }
                    })
                        .catch(() => { });
                    resolve(this.failClosed(request.destinationCountry));
                }, ESIM_TIMEOUT_MS);
                // Build and send the message
                const data = {
                    destinationCountry: request.destinationCountry,
                    rentalDays: request.rentalDays,
                    esimQuantity: request.esimQuantity,
                    currency: request.currency,
                    sessionUserId: getCookieShopify(),
                };
                const message = new SocketWrapperMessage();
                message.event = RentalServiceEvent.ESIM_VALIDATE_REQUEST;
                message.data = JSON.stringify(data);
                message.isCache = false;
                message.ip = "";
                this.eventBusSocket.send(message);
            });
        };
        this.application = container.resolve("IRegisterEventServiceBus");
        this.eventBusSocket = container.resolve("IEventBusSocket");
    }
    failClosed(country) {
        return {
            available: false,
            priceUsd: 0,
            priceLocal: 0,
            esimTotalUsd: 0,
            esimTotalLocal: 0,
            conversionRate: 0,
            coverageDays: 0,
            destination: country,
        };
    }
}
